import axios from 'axios';

// Backend 서버에게 인증 정보 검증을 요청하는 함수
/**
 * 백엔드 서버에게 인증 정보 검증을 요청하는 함수
 * @param {String} state 
 * @param {String} code 
 * @param {Number} type 
 * @param {String} data
 * @return {Promise<Object>}
 */
async function verifyAuthRequest(state, code, type, data = '') {
  // Type check
  if (typeof state !== 'string' || typeof code !== 'string' || typeof type !== 'number' || typeof data !== 'string') {
    throw new TypeError('\'verifyAuthRequest\' function parameter type error');
  }
  try {
    // Call api
    const res = await axios.post('/api/v1/verify/auth', {
      state, code, type, data,
    });
    if (res.data && res.data.data) return res.data.data;
    throw new Error('Invalid response format');
  } catch (err) {
    // If error response is well-formatted
    if (err.response && err.response.data && err.response.data.message && err.response.data.status) {
      const e = new Error(err.response.data.message);
      e.status = err.response.data.status;
      console.log(JSON.stringify(err.response, null, 4));
      throw e;
    } else { // If error response is not well-formatted
      const e = new Error(err.message);
      throw e;
    }
  }
}

export default verifyAuthRequest;